import React from 'react'

const FormControlHint = ({children, ...rest}) => {
  return (
    <div className='text-muted fs-7 ms-1' {...rest}>{children}</div>
  )
}

export default FormControlHint